"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SendEmailCode = void 0;
var tslib_1 = require("tslib");
var fetch_1 = require("../../../library/fetch");
var certification_1 = require("../../model/certification");
var service_1 = require("../../../library/base/service");
var SendEmailCode = /** @class */ (function (_super) {
    (0, tslib_1.__extends)(SendEmailCode, _super);
    function SendEmailCode() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = '发送邮箱验证码';
        _this.code = '101168';
        _this.desc = '发送邮箱验证码';
        _this.requestParams = new certification_1.SendEmailCodeRequest();
        _this.method = fetch_1.Methods.POST;
        return _this;
    }
    return SendEmailCode;
}(service_1.BaseService));
exports.SendEmailCode = SendEmailCode;
//# sourceMappingURL=sendEmailCode.js.map